import angular from 'angular';
import cloneDeep from 'clone-deep';

/* @ngInject */
export default function (params) {
	const ITEM_UPLOAD = 'Upload Document';
	const ITEM_ADD    = 'New Directory';
	const ITEM_EDIT   = 'Edit';
	const ITEM_DELETE = 'Delete';

	let {
		    $scope,
		    toastr,
		    DocumentsDirectories,
		    STATUSES,
		    $state,
	    } = params;

	$scope.treeRefreshOnUpdate = (new Date()).getTime();

	$scope.treeContextMenuItems = [
		ITEM_UPLOAD,
		ITEM_ADD,
		ITEM_EDIT,
		ITEM_DELETE,
	];

	$scope.directories = {
		data:   [],
		status: STATUSES.UNLOADED,
	};

	$scope.syncSelectedTreeDirectoryWithSelectedScopeDirectory = (newValue) => {
		$scope.treeSelectedDirectoryId = (newValue !== undefined) ? (newValue) : ($scope.directoryId);
	};

	$scope.treeDragDropAction = (directoryId, before, after) => {
		$scope.documentDeselectDocument();

		$scope.directoryMoveDirectory(directoryId, before, after);
	};

	$scope.treeContextMenuItemAction = (item, directoryId) => {
		$scope.documentDeselectDocument();

		switch (item) {
			case ITEM_UPLOAD: {
				$scope.directoryUploadDocument(directoryId);

				break;
			}

			case ITEM_ADD: {
				$scope.directoryNewDirectory(directoryId);

				break;
			}

			case ITEM_EDIT: {
				$scope.directoryEditDirectory(directoryId);

				break;
			}

			case ITEM_DELETE: {
				$scope.directoryDeleteDirectory(directoryId);

				break;
			}

			default: {
				break;
			}
		}
	};

	$scope.treeDirectorySelected = (directoryId) => {
		$scope.documentDeselectDocument();

		$scope.directoryId = directoryId;

		$state.go('staff.documents.root', {
			directoryId: $scope.directoryId,
		});
	};

	$scope.treeUpdateDirectoryEntity = (directory) => {
		$scope.indexDirectoryById(directory);
	};

	$scope.refreshDirectories = () => {
		$scope.directories.status = STATUSES.LOADING;
		$scope.directories.data   = [];

		DocumentsDirectories.getList({
			                    include: 'descendants,documents.latestVersion',
		                    })
		                    .then((data) => {
			                    const moveDescendantsToChildren = (rootDirectories) => {
				                    let directories = [];

				                    angular.forEach(rootDirectories, (rootDirectory) => {
					                    let directory = cloneDeep(rootDirectory);

					                    if (rootDirectory.descendants !== undefined) {
						                    directory.children = [
							                    ...cloneDeep(rootDirectory.descendants),
						                    ];

						                    delete directory.descendants;
					                    } else if (rootDirectory.children === undefined) {
						                    directory.children = [];
					                    }

					                    if (rootDirectory.documents === undefined) {
						                    directory.documents = [];
					                    }

					                    directories.push(directory);
				                    });

				                    return directories;
			                    };

			                    const normalizeDirectories = (rootDirectories) => {
				                    let directories = [];

				                    angular.forEach(rootDirectories, (rootDirectory) => {
					                    if (rootDirectory.children === undefined) {
						                    rootDirectory.children = [];
					                    } else {
						                    rootDirectory.children = normalizeDirectories(rootDirectory.children);
					                    }

					                    if (rootDirectory.documents === undefined) {
						                    rootDirectory.documents = [];
					                    }

					                    directories.push(rootDirectory);
				                    });

				                    return directories;
			                    };

			                    let directories = moveDescendantsToChildren(data);

			                    directories = normalizeDirectories(directories);

			                    $scope.indexEntitiesById(directories);

			                    $scope.directories.data   = $scope.directoriesById;
			                    $scope.directories.status = STATUSES.LOADED;

			                    $scope.syncSelectedTreeDirectoryWithSelectedScopeDirectory();

			                    $scope.refreshDirectory();
		                    })
		                    .catch((error) => {
			                    toastr.clear();
			                    toastr.error('There was an error while loading the document manager, please try again.', 'Error');

			                    $scope.directories.status = STATUSES.ERRORED;
		                    });
	};

	$scope.$watch('directoryId', (newValue) => {
		$scope.syncSelectedTreeDirectoryWithSelectedScopeDirectory();
	});
}


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/documents/root/controllers/tree/index.js